"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var SliderList = _styledComponents.default.div.withConfig({
  displayName: "SliderList",
  componentId: "sc-1m9uvy5-0"
})(["height:100%;transform:translateX(", ");transition:transform 0.6s ease-in-out;"], function (_ref) {
  var translateX = _ref.translateX;
  return translateX ? "-".concat(translateX, "%") : '0%';
});

var _default = SliderList;
exports.default = _default;